// src/components/Ujdonsag.jsx

import { Box } from "@chakra-ui/react";
import HoverBox from "./HoverBox";

const Ujdonsag = () => {
  return (
    <Box
      py={{ base: 10, md: 14 }}
      px={{ base: 4, md: 6 }}
      display="flex"
      justifyContent="center"
      flexWrap="wrap"
      gap={{ base: 5, md: 7 }}
    >
      <HoverBox
        text="4 Tojásos levestésztáink"
        image="/images/laskodihoverbox1.png"
        link="/tesztaink/4-levestészta"
      />

      <HoverBox
        text="8 Tojásos levestésztáink"
        image="/images/laskodihoverbox2.png"
        link="/tesztaink/8-levestészta"
      />

      <HoverBox
        text="4 Tojásos körettésztáink"
        image="/images/laskodihoverbox3.png"
        link="/tesztaink/4-körettészta"
      />

      {/* 
            <HoverBox
                text="8 Tojásos körettésztáink"
                image="/images/pasta4.jpg"
                link="/tesztaink/8-körettészta"
            /> 
            */}
    </Box>
  );
};

export default Ujdonsag;